var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"radarChart",attrs:{"height":300,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }